import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';



export function getViewRecommenderOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/recommender-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageRecommenders(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-recommenders`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageRecommenderOutput(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-recommender-output`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewRecommenderConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/recommender-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewRecommenderEditor(recommenderId=null) {
  if (recommenderId) {
      return `view/extensions/recommender-editor/${recommenderId}`;
  } else {
      return `view/extensions/recommender-editor`;
  }
}

export function getViewRecommenderEditor(successCallback, errorCallback, recommenderId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewRecommenderEditor(recommenderId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathRecommenders(recommenderId=null) {
  if (recommenderId) {
      return `extensions/recommenders/${recommenderId}`;
  } else {
      return `extensions/recommenders`;
  }
}

export function getRecommenders(successCallback, errorCallback, recommenderId) {
  getAuth({
    "path": pathRecommenders(recommenderId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function createRecommenders(successCallback, errorCallback, data) {
  postAuth({
    "path": pathRecommenders(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchRecommenders(successCallback, errorCallback, data, recommenderId) {
  patchAuth({
    "path": pathRecommenders(recommenderId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteRecommenders(successCallback, errorCallback, recommenderId) {
  deleteAuth({
    "path": pathRecommenders(recommenderId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function postUpdateRecommenderModel(successCallback, errorCallback, recommenderId) {
  postAuth({
    "path": `extensions/recommenders/${recommenderId}/update-model`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getRecommenderOptions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`extensions/recommender-options`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Settings
function pathViewRecommenderSettingsShforms() {
  return `view/extensions/recommender-settings-shforms`;
}

export function getViewRecommenderSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewRecommenderSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathRecommenderSettings() {
  return `extensions/recommender-settings`;
}

export function patchRecommenderSettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathRecommenderSettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


// Analytics
export function getViewRecommenderAnalytics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/recommender-analytics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Conversions
export function getViewManageRecommenderConversions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-recommender-conversions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

